export type AzureStorageNameValidation = { valid: true } | { valid: false; reason: string };

const valid = (): AzureStorageNameValidation => ({ valid: true });
const invalid = (reason: string): AzureStorageNameValidation => ({ valid: false, reason });
const SYSTEM_CONTAINERS = new Set(['$root', '$web', '$logs']);

export function validateAzureContainerName(name: string): AzureStorageNameValidation {
  if (SYSTEM_CONTAINERS.has(name)) return valid();
  if (name.length < 3 || name.length > 63) return invalid('Container names must contain 3 to 63 characters.');
  if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(name)) return invalid('Use lowercase letters, numbers, and single hyphens; start and end with a letter or number.');
  if (name.includes('--')) return invalid('Consecutive hyphens are not allowed.');
  return valid();
}
